import {alpha, BottomNavigation, BottomNavigationAction, Paper, styled} from '@mui/material';

export const StyledPaper = styled(Paper)`
	position: fixed;
	z-index: 3;
	bottom: 0;
	left: 0;
	right: 0;
	box-shadow:
		0px 1px 8px 0px rgba(0, 0, 0, 0.12),
		0px 3px 4px 0px rgba(0, 0, 0, 0.14),
		0px 3px 3px -2px rgba(0, 0, 0, 0.2);
`;

export const StyledBottomNavigation = styled(BottomNavigation)`
	background: #fff;
	height: 64px;
	border-top: 1px solid #e9eaeb;
`;

export const NavigationItem = styled(BottomNavigationAction)`
	position: relative;
	min-width: 0;
	padding: 12px;

	.MuiBottomNavigationAction-wrapper {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 2px;
	}

	.MuiSvgIcon-root {
		font-size: 12px;
	}

	.MuiBottomNavigationAction-label {
		margin-top: 5px;
		font-size: 12px;
		font-weight: 600;
	}

	&.Mui-selected {
		.MuiSvgIcon-root {
			font-size: 12px;
		}

		.MuiBottomNavigationAction-label {
			font-size: 12px;
		}

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 1px;
			background: ${({theme}) => theme.palette.primary.main};
		}
	}

	/* Divider */
	&:not(:last-child)::after {
		content: '';
		position: absolute;
		right: 0;
		top: 20%;
		height: 36px;
		width: 1px;
		background: #e9eaeb;
	}
`;

export const StyledModalButton = styled('div')`
	justify-content: center;
	display: flex;
	min-width: inherit;

	&:is(:hover) {
		background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.08)};
		color: ${({theme}) => theme.palette.primary.main};

		.MuiBottomNavigationAction-label {
			font-size: 0.875rem;
		}
	}

	& .MuiBottomNavigationAction-label {
		${({theme}) => theme.breakpoints.down(375)} {
			display: none;
		}
	}

	& .MuiTouchRipple-root .MuiTouchRipple-child {
		background-color: ${({theme}) => theme.palette.primary.main};
	}
`;
